var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.773 9.254c-.076-4.054-3.218-7.328-7.077-7.328h-.566c-3.859 0-7.001 3.274-7.077 7.327a2.26 2.26 0 00-1.14 1.956v1.133A2.269 2.269 0 004.18 14.61a2.269 2.269 0 002.266-2.267V11.21a2.268 2.268 0 00-2.245-2.265C4.423 5.661 6.994 3.06 10.13 3.06h.566c3.137 0 5.707 2.6 5.929 5.884a2.268 2.268 0 00-2.245 2.265v1.133c0 1.024.685 1.88 1.618 2.16a5.977 5.977 0 01-3.399 2.205 1.412 1.412 0 00-2.753.452c0 .782.634 1.416 1.417 1.416.49 0 .946-.256 1.202-.674a7.126 7.126 0 004.927-3.429 2.26 2.26 0 001.52-2.13V11.21c0-.838-.462-1.563-1.14-1.955zm-12.46 1.955v1.133a1.134 1.134 0 01-2.267 0V11.21a1.134 1.134 0 012.267 0zm12.467 1.133c0 .608-.482 1.101-1.083 1.128l-.044-.02-.014.024a1.133 1.133 0 01-1.126-1.132V11.21a1.134 1.134 0 012.267 0v1.133z",
    stroke: "#FFF",
    strokeWidth: 0.2,
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/assets/customer.593a9e02.svg";
export { ForwardRef as ReactComponent };